import { useLocation, Link } from "react-router-dom";
const ProductInquiryDetail = () => {
  const location = useLocation();
  const data = location.state;

  const product = data?.Product;
  const catalogue = data?.Catalogue;
  const item = product || catalogue;

  const type = product ? "Product" : catalogue ? "Catalogue" : "";

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="page-title">Product Inquiry</h3>
      </div>

      <div className="row grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row g-3">
                  <div className="col-lg-6 col-md-12 mb-3">
                    <label>Email</label>
                    <input
                      type="text"
                      className="form-control border border-dark"
                      value={data?.email || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 mb-3">
                    <label>Mobile</label>
                    <input
                      type="text"
                      className="form-control border border-dark"
                      value={data?.mobile_number || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 mb-3">
                    <label>Type</label>
                    <input
                      type="text"
                      className="form-control border border-dark"
                      value={type || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 mb-3">
                    <label>SKU</label>
                    <input
                      type="text"
                      className="form-control border border-dark"
                      value={item?.sku || item?.cat_code || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 mb-3">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control border border-dark"
                      value={item?.name || ""}
                      disabled
                    />
                  </div>
                 
                  <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                      className="form-control border border-dark"
                      rows="5"
                      value={data?.description || ""}
                      disabled
                      style={{ whiteSpace: "pre-wrap" }}
                    />
                  </div>
                  <div className="col-12 mt-4 text-center">
                    <Link to="/product-inquiry">
                      <button type="button" className="btn btn-danger">
                        Back
                      </button>
                    </Link>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInquiryDetail;